import { DEFAULT_DATE_FORMAT_PATTERN } from "../../../../shared/DataFormatSection/constants";
import { DEFAULT_DATE_PERIOD_VALUES } from "../../../../shared/DatePeriodSection/constants";
import type { FieldSettingsValues } from "./types";
import type { DataFormatValues } from "../../../../shared/DataFormatSection/types";

const DEFAULT_DATA_FORMAT_VALUES: DataFormatValues = {
  decimalPlaces: 2,
  negativeNumbers: "parentheses",
  numberScale: "as_is",
  thousandsSeparator: true,
  showCurrencySymbol: true,
  currencySymbolPosition: "left",
  zeroDisplay: "number",
  nullDisplay: "blank",
  dateFormatPattern: DEFAULT_DATE_FORMAT_PATTERN,
};

export const DEFAULT_FIELD_SETTINGS_VALUES: FieldSettingsValues = {
  fieldType: "QUANTITY",
  overrideDecimalPlaces: false,
  overrideFormat: false,
  format: DEFAULT_DATA_FORMAT_VALUES,
  datePeriod: DEFAULT_DATE_PERIOD_VALUES,
  levels: [],
  formulaComponents: {},
  formulaComponentsResolved: false,
  filterRules: { groupsOperator: "and", groups: [] },
  suppressionRules: { groupsOperator: "and", groups: [] },
};
